export function DeleteNullish(data, options) {
    const object = new Map(Object.entries(data));
    object.forEach((value, key) => {
        if (!Truthy(value))
            object.delete(key);
        if (options?.removeEmptyString && value === '')
            object.delete(key);
        if (options?.removeFalse && value === false)
            object.delete(key);
    });
    return Object.fromEntries(object);
}
//# sourceMappingURL=deleteNullish.js.map